<script lang="ts">
	interface Props {
		label?: string
		error?: string
		accept?: string
		disabled?: boolean
		onFileSelected?: ((file: File | null) => void) | null
	}

	let {
		label = '',
		error = '',
		accept = '.csv',
		disabled = false,
		onFileSelected = null
	}: Props = $props()

	let file: File | null = null

	function handleFileSelect(event: Event): void {
		const inputElement: HTMLInputElement = event.target as HTMLInputElement
		file = inputElement.files ? inputElement.files[0] : null
		onFileSelected?.(file)
	}
</script>

<label class="block">
	{#if label}
		<span class="block">{label}</span>
	{/if}
	<input
		type="file"
		{accept}
		onchange={handleFileSelect}
		class="block input"
		class:error
		{disabled}
	/>
	{#if error}
		<span class="block error-text">{error}</span>
	{/if}
</label>

<style>
	.input {
		border-radius: 4px;
		padding: 6px 10px;
		margin: 0;
		width: 100%; /* To fit most of potential texts */
	}

	.block {
		display: block;
	}

	.error {
		border-color: #f55;
	}

	.error-text {
		color: #f55;
	}
</style>
